import  { useEffect, useState } from 'react'
import { Footer } from '../../../components/footer';
import { Link, useNavigate } from 'react-router-dom';
import { yupResolver } from '@hookform/resolvers/yup';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useToast } from '../../../hook/usetoast';
import { useCreateTicket } from './api/api';
import { useAccount } from 'wagmi';
import { useProfileDetails } from '../../profile-details/api/profileapi';
import Loader from '../../Loader/buttonLoad';

const CreateTicket = () => {
   const toast = useToast();

   const EMAILID_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

   const schema = yup.object().shape({
      userName: yup.string()
         .matches(/^[a-zA-Z\s]*$/, "Username cannot contain numbers")
         .min(3, 'Name must be at least 3 characters')
         .max(30, 'Name must be at most 30 characters')
         .required('Name is Required'),
      email: yup.string()
         .matches(EMAILID_REGEX, "Invalid Email")
         .max(140, 'Email must be at most 140 characters')
         .required('Email is Required'),
      subject: yup.string()
         .max(100, 'Subject must be at most 100 characters')
         .required('Subject is Required'),
      description: yup.string()
         .required('Issue details are Required'),
      image: yup
         .mixed()
         .test("required", "Image required", (file) => !!file),
   });
   const { data: getProfile } = useProfileDetails()
   const navigate=useNavigate()
   const {
      register,
      control,
      handleSubmit,
      formState: { errors, isDirty, isValid },
      setValue,
      setError,
      clearErrors,
   } = useForm({
      mode: 'onChange',
      resolver: yupResolver(schema),
      defaultValues: {
         userName: getProfile?.username,
         email: getProfile?.email,
         subject: "",
         image: "",
         description: ""
      }
   });

   const [issueImg, setIssueImg] = useState(null);
   const { address } = useAccount();
   useEffect(() => {
      setValue("email", getProfile?.email)
      setValue("userName", getProfile?.username)
   }, [getProfile, setValue])


   // helper to convert file to base64 for preview
   const readFileAsync = (file) => {
      return new Promise((resolve, reject) => {
         if (!file) return;
         const reader1 = new FileReader();
         reader1.onload = () => resolve(reader1.result);
         reader1.onerror = reject;
         reader1.readAsDataURL(file);
      });
   };

   // validate dimensions and size, set preview + form value
   const SelfieImg = (file) => {
      const reader = new FileReader();

      reader.onload = (event) => {
         const imgCheck = new Image();
         imgCheck.src = event.target.result;

         imgCheck.onload = async () => {
            if (imgCheck.width <= 6000 && imgCheck.height <= 6000) {
               if (file.size < 2 * 1024 * 1024) {
                  const newImage1 = await readFileAsync(file);
                  setIssueImg(newImage1);

                  setValue("image", file, {
                     shouldDirty: true,
                     shouldValidate: true,
                  });
               } else {
                  toast.error('Image Size Must be Less than 2MB.');
                  setError('image', {
                     type: 'manual',
                     message: 'Image Size Must be Less than 2MB.',
                  });
               }
            } else {
               toast.error('Image Dimensions should be 6000 x 6000 Pixels.');
               setError('image', {
                  type: 'manual',
                  message: 'Image Dimensions should be 6000 x 6000 Pixels.',
               });
            }
         };

         imgCheck.onerror = () => {
            toast.error('Invalid image file');
         };
      };

      reader.onerror = () => {
         toast.error('Unable to load image');
      };

      reader.readAsDataURL(file);
   };

   // check file signature (PNG/JPG) then call SelfieImg
   const handleImageChange = (e) => {
      try {
         const file = e.target.files?.[0];
         if (!file) {
            setIssueImg(null);
            setValue('image', null);
            clearErrors('image');
            return;
         }

         const reader = new FileReader();
         clearErrors("image");
         setValue("image", null);
         setIssueImg(null);

         reader.onload = (event) => {
            const bytes = new Uint8Array(event.target.result);
            const isPng = bytes[0] === 0x89 && bytes[1] === 0x50; // PNG
            const isJpg = bytes[0] === 0xFF && bytes[1] === 0xD8; // JPG/JPEG

            if (isPng || isJpg) {
               SelfieImg(file);
            } else {
               toast.error('Please select image file (PNG/JPG)');
               setError('image', {
                  type: 'manual',
                  message: 'Please select a valid PNG or JPG image'
               });
            }
         };

         reader.onerror = () => {
            toast.error('Unable to read file');
         };

         reader.readAsArrayBuffer(file);
      } catch (err) {
      }
   };
   const createTicket = useCreateTicket()
   const onSubmit = async (data) => {
      try {
         const formData = new FormData();
         formData.append('userName', data.userName);
         formData.append('email', data.email);
         formData.append('subject', data.subject);
         formData.append('description', data.description);
         formData.append('address', address.toLowerCase());
         formData.append('userId', getProfile?.userId);
            formData.append('image', data.image);

         const res = await createTicket.mutateAsync(formData)
         if(res?.status){
            toast.success()
            navigate('/support-ticket')
         }

      } catch (error) {

      }

   };

   return (
      <>
      {createTicket.isLoading && <Loader />}
         <div className="mainContent">
            <div className="pageContent def-py-30">
               <div className='container'>

                  <div className="appPagetitle d-flex g-10 align-items-center">
                     <Link to={'/support-ticket'} className='btn btnBack'>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path d="M4.16699 10H15.8337" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                           <path d="M4.16699 10L7.50033 13.3333" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                           <path d="M4.16699 10.0003L7.50033 6.66699" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                     </Link>
                     <span>Create  Ticket</span>
                  </div>

                  <div className='row'>
                     <div className="col-lg-12">

                        <div className="appcard pb-3 cardbg">
                           <div className="row">
                              <div className="col-lg-8 mx-auto">

                                 {/* form start */}
                                 <form onSubmit={handleSubmit(onSubmit)} noValidate>
                                    <div className="row">
                                       <div className="col-md-6">
                                          <div className="form-group formInputs">
                                             <label htmlFor='username'>Username</label>
                                             <input
                                                className={`form-control ${errors.userName ? 'is-invalid' : ''}`}
                                                id="username"
                                                type='text'
                                                readOnly
                                                placeholder='Enter Your Username'
                                                {...register('userName')}
                                             />
                                             {errors.userName && (
                                                <span className="invalid-feedback d-block">
                                                   {errors.userName.message}
                                                </span>
                                             )}
                                          </div>

                                          <div className="form-group formInputs">
                                             <label htmlFor='EmailAddress'>Email Address</label>
                                             <input
                                                className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                                                id='EmailAddress'
                                                type='text'
                                                readOnly
                                                placeholder='Enter Your Email Address'
                                                {...register('email')}
                                             />
                                             {errors.email && (
                                                <span className="invalid-feedback d-block">
                                                   {errors.email.message}
                                                </span>
                                             )}
                                          </div>

                                          <div className="form-group formInputs">
                                             <label htmlFor='subject'>Subject</label>
                                             <input
                                                className={`form-control ${errors.subject ? 'is-invalid' : ''}`}
                                                id='subject'
                                                type='text'
                                                placeholder='Enter Subject'
                                                {...register('subject')}
                                             />
                                             {errors.subject && (
                                                <span className="invalid-feedback d-block">
                                                   {errors.subject.message}
                                                </span>
                                             )}
                                          </div>
                                       </div>

                                       <div className="col-md-6">
                                          <div className="form-group formInputs">
                                             <label htmlFor='IssuesDetails'>Issues Details</label>
                                             <textarea
                                                className={`form-control h-auto ${errors.description ? 'is-invalid' : ''}`}
                                                rows={10}
                                                id="IssuesDetails"
                                                placeholder="Describe your issue"
                                                {...register('description')}
                                             />
                                             {errors.description && (
                                                <span className="invalid-feedback d-block">
                                                   {errors.description.message}
                                                </span>
                                             )}
                                          </div>
                                       </div>

                                       <div className="col-md-12">
                                          <div className="form-group formInputs">
                                             <label htmlFor='fileUpload'>Image Upload</label>
                                             <div id="file" className="tkFlUp">
                                                <Controller
                                                   name="image"
                                                   control={control}
                                                   render={({ field }) => (
                                                      <>
                                                         <input
                                                            type="file"
                                                            id="fileUpload"
                                                            accept=".png,.jpg,.jpeg"
                                                            onChange={(e) => {
                                                               const file = e.target.files?.[0] || null;
                                                               field.onChange(file);
                                                               handleImageChange(e);
                                                            }}
                                                         // style={{ display: 'none' }} // optionally hide input via CSS
                                                         />

                                                         <label className="tkFlUpInr" htmlFor="fileUpload">
                                                            {/* Show upload icon + texts only when NO image */}
                                                            {!issueImg && (
                                                               <>
                                                                  <svg
                                                                     className="mb-1"
                                                                     width="25"
                                                                     height="27"
                                                                     viewBox="0 0 25 27"
                                                                     fill="none"
                                                                     xmlns="http://www.w3.org/2000/svg"
                                                                  >
                                                                     <path
                                                                        d="M1 19.4141V22.2474C1 22.9988 1.29851 23.7195 1.82986 24.2509C2.36122 24.7822 3.08189 25.0807 3.83333 25.0807H20.8333C21.5848 25.0807 22.3054 24.7822 22.8368 24.2509C23.3682 23.7195 23.6667 22.9988 23.6667 22.2474V19.4141"
                                                                        stroke="white"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                     />
                                                                     <path
                                                                        d="M5.25 8.08333L12.3333 1L19.4167 8.08333"
                                                                        stroke="white"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                     />
                                                                     <path
                                                                        d="M12.3334 1V18"
                                                                        stroke="white"
                                                                        strokeWidth="2"
                                                                        strokeLinecap="round"
                                                                        strokeLinejoin="round"
                                                                     />
                                                                  </svg>
                                                                  <span>Upload Image</span>
                                                                  <span>Image Support PNG JPG</span>
                                                                  <span className="ylw">Click to Upload</span>
                                                               </>
                                                            )}

                                                            {issueImg && (
                                                               <div className="tkFlUpPreview mt-2">
                                                                  <img
                                                                     src={issueImg}
                                                                     alt="Preview"
                                                                     className="img-fluid"
                                                                     style={{ maxHeight: 150, objectFit: 'contain' }}
                                                                  />
                                                               </div>
                                                            )}
                                                         </label>
                                                      </>
                                                   )}
                                                />
                                             </div>
                                             {errors.image && (
                                                <span className="invalid-feedback d-block">
                                                   {errors.image.message}
                                                </span>
                                             )}


                                          </div>

                                          <div className='mt-4 mb-3'>
                                             <button
                                                type="submit"
                                                className='btn btn-primary'
                                                disabled={!isDirty || !isValid}
                                             >
                                                Submit
                                             </button>
                                          </div>

                                       </div>
                                    </div>
                                 </form>

                              </div>
                           </div>
                        </div>

                     </div>
                  </div>

               </div>
            </div>
         </div>
         <Footer />
      </>
   );
};

export default CreateTicket;